import { type FunctionComponent } from 'react';
import { PlaceholderImage } from '../../images/placeholder-image/placeholder-image.component';
import SlidersIcon from '../../svgs/untitled-ui/sliders.svg';

export type FacetGroupSkeletonProps = {
	showSubheading?: boolean;
};

const FacetGroupSkeleton: FunctionComponent<FacetGroupSkeletonProps> = ({ showSubheading = false }) => {
	return (
		<div className="bb b--theme-grey-light mh1 mh0-l">
			<div className="w-100 pv4 pv3-l ph2">
				<div className="flex items-center gc1">
					{/* Facet group name */}
					<PlaceholderImage className="br2" width={120} height={20} />
					{/* Expand/collapse icon placeholder */}
					<div className="ml-auto flex-shrink-0">
						<PlaceholderImage className="br2" width={20} height={20} />
					</div>
				</div>
				{/* Selected facets subheading */}
				{showSubheading && (
					<div className="fade-in mt2 font-light w-100">
						<PlaceholderImage className="br2" width={150} height={14} />
					</div>
				)}
			</div>
		</div>
	);
};

export type FacetListSkeletonProps = {
	count?: number;
};

export const FacetListSkeleton: FunctionComponent<FacetListSkeletonProps> = ({ count = 6 }) => {
	return (
		<section data-testid="facet-list-skeleton">
			<div className="bb b--theme-grey-light f4 font-medium flex-ns items-center justify-between pb2 pl2 pr1 lh-solid dn ma0">
				<SlidersIcon data-testid="SlidersIcon" />
				<span className="ml2 flex-grow-1">Filters</span>
				<PlaceholderImage className="br2" width={80} height={16} />
			</div>
			<div>
				{Array.from({ length: count }).map((_, index) => (
					<FacetGroupSkeleton key={index} showSubheading={index % 3 === 0} />
				))}
			</div>
		</section>
	);
};
